// src/ArchiveIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var ArchiveIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.4347 2.83331C17.567 3.04123 17.3404 3.28344 17.1001 3.22883C16.6301 3.08883 16.1101 3.01883 15.5801 3.01883H12.2798C12.1226 3.01883 11.9745 2.94488 11.8801 2.8192L10.7301 1.28883C10.5892 1.08927 10.7224 0.798828 10.9666 0.798828H13.7201C15.2811 0.798828 16.6561 1.60956 17.4347 2.83331Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M18.14 5.33883C17.71 5.02883 17.22 4.79883 16.69 4.66883C16.33 4.56883 15.96 4.51883 15.58 4.51883H11.86C11.28 4.51883 11.24 4.46883 10.93 4.05883L9.53 2.19883C8.88 1.32883 8.37 0.798828 6.74 0.798828H4.42C1.98 0.798828 0 2.77883 0 5.21883V16.3788C0 18.8188 1.98 20.7988 4.42 20.7988H15.58C18.02 20.7988 20 18.8188 20 16.3788V8.93883C20 7.44883 19.27 6.13883 18.14 5.33883Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.56952 17.3658L6.07645 13.8727C5.95431 13.7506 5.89732 13.5959 5.89732 13.4412C5.89732 13.2865 5.95431 13.1318 6.07645 13.0096C6.31258 12.7735 6.70341 12.7735 6.93954 13.0096L9.39039 15.4605L9.39039 7.16341C9.39039 6.82957 9.66723 6.55273 10.0011 6.55273C10.3349 6.55273 10.6117 6.82957 10.6117 7.16341L10.6117 15.4605L13.0626 13.0096C13.2987 12.7735 13.6896 12.7735 13.9257 13.0096C14.1618 13.2458 14.1618 13.6366 13.9257 13.8727L10.4326 17.3658C10.3186 17.4798 10.1639 17.5449 10.0011 17.5449C9.83822 17.5449 9.68352 17.4798 9.56952 17.3658Z",
          fill: "#838AAA"
        }
      )
    ]
  }
);
var ArchiveIcon_default = ArchiveIcon;

export {
  ArchiveIcon_default
};
